
import $config from '@/config'
/**
 * 判断当前是否是福田的地址
 * @param {*} 
 * @return true
 */
export const isFoTon = () => {
    let result = false
    // if ($config.publicinfo.webhost == '/wjgl') {
    //     result = true
    // }
    return result;
}